<div class="dev-comment">src\app\landowner-admin-shared\components\season-lookup-picker\season-lookup-picker.component.html</div>
<auto-complete-drop-down
  [items]="items"
  (selected)="onSeasonLookupSelected($event)"
  [placeholder]="placeholder"
>
</auto-complete-drop-down>
